const sanitizeString = (string) => {
  const stringWhitoutAccent = string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const stringInLowerCase = stringWhitoutAccent.toLowerCase();

  return stringInLowerCase;
};

export default sanitizeString;
